// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/newstyle.css
// module id = 1667
// module chunks = 4